import { Component, EventEmitter, Inject, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { MatSelectionList, MatSelectionListChange, MatListModule } from '@angular/material/list';
import { Utils } from '../../../../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'ownergroupfunction',
  standalone: true,
  imports: [
    MatListModule,
    MatIconModule
  ],
  templateUrl: './ownergroupfunction.component.html',
  styleUrls: ['./ownergroupfunction.component.less']
})
export class OwnergroupfunctionComponent implements OnChanges {
    @Input() public hierarchyType: string | undefined;
    @ViewChild(MatSelectionList) selectionList!: MatSelectionList;
    @Output() selectedKPIOwners = new EventEmitter<string[]>();


    mersySections: Reference[] = [];

    constructor(
        private readonly http: HttpClient,
        @Inject('BASE_URL') private readonly baseUrl: string,
    ) {
        this.funcGetKPIDefinitionRef();
    }

    ngOnChanges() {
        console.log(this.hierarchyType);
    }

    onSelectRelatedSection(event: MatSelectionListChange) {
        const selectedValues = this.selectionList.selectedOptions.selected.map(option => option.value.Value);
        this.selectedKPIOwners.emit(selectedValues);
    }

    funcGetKPIDefinitionRef() {
        Utils.httpGetKPIDefinitionRef(
            this.http
            , this.baseUrl
            , this
            , function (tthis: OwnergroupfunctionComponent, result: any) {
                tthis.mersySections = result.filter(x => x.Key === "KpiOwner");
            }, null
        )

    }

}
